export default function() {
  
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
  <!-- Slider Main Container -->
  <div class="swiper-container">
    <div class="swiper-button-prev"></div>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
        <!-- Slides -->
    </div>
    <div class="swiper-button-next"></div>
  </div>
  `;


  // Slide Template
  function buildSlideTemplate(slide) {

    const title = `<h2>${slide.Title.slice(0, 26)}</h2>`;
    const description = slide.Description ? `<p>${slide.Description}</p>` : '';

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
          </div>
          <a class="swiper-content-container" href="${slide.URL}">
            ${title}
            ${description}
          </a>
      </div>
    `;

    return template;
  }


  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);

    widgetData.forEach(function(slide, i) {
      swiperWidgetWrapper.append(buildSlideTemplate(slide));
    });

    const swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: {
        delay: 80000,
      },
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,     
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }); 

  }

  
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function(response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
      // console.log(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });

}
